import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateStringPipe } from '../../../pipes/translate-string/translate-string.pipe';
import { CapitalizeFirstLetterPipe } from './capitalize-first-letter.pipe';
import { FilterPipe } from './filter.pipe';
import { LocaliseNumberDigitsInfoPipe } from './localise-number-digits-info';
import { LocalizeNumberPipe } from './localize-number.pipe';
import { LowercaseReplaceSpaceWithDashPipe } from './lowercase-replace-space-with-dash.pipe';
import { TranslateChangedFromToValuePipe } from './translate-changed-from-to-value.pipe';
import { TranslateParameterPipe } from './translate-parameter.pipe';
import { TranslateStringNestedPipe } from './translate-string-nested/translate-string-nested.pipe';
import { TranslateStringWithNumberPipe } from './translate-string-with-number.pipe';
import { TranslateUnitPipe } from './translate-unit.pipe';

const PIPES = [
  TranslateParameterPipe,
  TranslateChangedFromToValuePipe,
  TranslateUnitPipe,
  TranslateStringWithNumberPipe,
  LocalizeNumberPipe,
  FilterPipe,
  LowercaseReplaceSpaceWithDashPipe,
];

@NgModule({
  declarations: [PIPES],
  imports: [
    CommonModule,
    TranslateStringPipe,
    TranslateStringNestedPipe,
    CapitalizeFirstLetterPipe,
    LocaliseNumberDigitsInfoPipe,
  ],
  exports: [PIPES, TranslateStringPipe, TranslateStringNestedPipe, CapitalizeFirstLetterPipe],
})
export class PipesModule {}
